export default {
  methods: {
    calculatePageOffset(currentPage, perPageSelectedValue) {
      return (currentPage - 1) * perPageSelectedValue + 1;
    },
  },
};
